export default {
  titles: {
    main: 'My table members',
    no_members: 'People that join your group will be listed here',
  },
  buttons: {
    leave_party: 'Not Ordering ? Click To Leave Table →',
  },
};